<div id="scroll-to-top-ref" class="subscribe-bar">
  <div class="klaviyo-form-ViPYDt"></div>
</div>

<!--Hero section-->
<section class="section-hero">
  <img src="assets/images/landing/home/philly-favorites-seal.png" class="hero__seal"
    alt="Voted a 2026 Philly Favorite by The Philadelphia Inquirer readers" />
  <div class="d-flex g-4 justify-content-between animated fadeInUp">
    <div>
      <div class="hero__detail">
        <h1 class="hero__title">Good Food<span class="hero__dot dot-is-blue">.</span></h1>
        <div class="hero__title">Good Neighbors<span class="hero__dot dot-is-blue">.</span></div>
        <div class="hero__title">A Better Food System for Philly<span class="hero__dot dot-is-blue">.</span></div>
        <p class="hero__text">
          Philly's online farmer's market, delivered.
        </p>
      </div>
      <section class="d-flex gap-3">
        <button class="hero__btn" (click)="openModalCheckAddress()">See if We Deliver To You</button>
        @if (!hasSession()) {
        <button class="hero__btn-login" [routerLink]="['/login']">Log In</button>
        }
      </section>
    </div>
  </div>
</section>


<section class="section-featured-in">
  <h3 class="title">FEATURED IN</h3>
  <div class="featured-logo-wrap">
    <div class="container">
      <div class="featured-logos">

        <a class="img" href="https://philly.citycast.fm/podcasts/phillys-best-grocery-stores-and-hidden-deals"
          target="_blank" rel="noopener noreferrer">
          <img src="assets/images/landing/home/featured-logos/city-cast-philly.webp" alt="City Cast Philly">
        </a>

        <a class="img"
          href="https://6abc.com/post/philly-food-works-misfits-market-making-house-calls-during-pandemic-%7C-fyi-philly/6089608/"
          target="_blank" rel="noopener noreferrer">
          <img src="assets/images/landing/home/featured-logos/6abc.webp" alt="6ABC">
        </a>

        <a class="img"
          href="https://www.inquirer.com/food/philly-food-works-how-subscription-boxes-csa-options-philadelphia-20200204.html"
          target="_blank" rel="noopener noreferrer">
          <img src="assets/images/landing/home/featured-logos/inquirier.webp" alt="Inquirer">
        </a>

        <a class="img"
          href="https://greenphl.com/philly/sustainability-with-substance-how-local-green-entrepreneurs-strive-for-success/"
          target="_blank" rel="noopener noreferrer">
          <img src="assets/images/landing/home/featured-logos/green-philly.webp" alt="Green Philly">
        </a>

        <a class="img" href="https://gridphilly.com/blog-home/2014/08/15/super-model-html/" target="_blank" rel="noopener noreferrer">
          <img src="assets/images/landing/home/featured-logos/grid.webp" alt="Grid">
        </a>

        <a class="img" href="https://www.pennsylvaniareview.com/philly-foodworks-review/" target="_blank" rel="noopener noreferrer">
          <img src="assets/images/landing/home/featured-logos/the-pa-review.webp" alt="The PA Review">
        </a>

        @if (isMobile()) {

        <!-- Duplicate logos for seamless carousel loop (hidden on lg+) -->

        <a class="img" href="https://philly.citycast.fm/podcasts/phillys-best-grocery-stores-and-hidden-deals"
          target="_blank" rel="noopener noreferrer">
          <img src="assets/images/landing/home/featured-logos/city-cast-philly.webp" alt="City Cast Philly">
        </a>

        <a class="img"
          href="https://6abc.com/post/philly-food-works-misfits-market-making-house-calls-during-pandemic-%7C-fyi-philly/6089608/"
          target="_blank" rel="noopener noreferrer">
          <img src="assets/images/landing/home/featured-logos/6abc.webp" alt="6ABC">
        </a>

        <a class="img"
          href="https://www.inquirer.com/food/philly-food-works-how-subscription-boxes-csa-options-philadelphia-20200204.html"
          target="_blank" rel="noopener noreferrer">
          <img src="assets/images/landing/home/featured-logos/inquirier.webp" alt="Inquirer">
        </a>

        <a class="img"
          href="https://greenphl.com/philly/sustainability-with-substance-how-local-green-entrepreneurs-strive-for-success/"
          target="_blank" rel="noopener noreferrer">
          <img src="assets/images/landing/home/featured-logos/green-philly.webp" alt="Green Philly">
        </a>

        <a class="img" href="https://gridphilly.com/blog-home/2014/08/15/super-model-html/" target="_blank" rel="noopener noreferrer">
          <img src="assets/images/landing/home/featured-logos/grid.webp" alt="Grid">
        </a>

        <a class="img" href="https://www.pennsylvaniareview.com/philly-foodworks-review/" target="_blank" rel="noopener noreferrer">
          <img src="assets/images/landing/home/featured-logos/the-pa-review.webp" alt="The PA Review">
        </a>
        }

      </div>
    </div>
  </div>
</section>


<section class="has-padding-block-2">
  <div class="container">
    <div class="row g-5">
      <div class="col-md-7 ">
        <div class="text-sm-start text-center mb-5">
          <h2 class="main-text">
            Good food doesn't just taste better<span class="dot-is-blue">.</span><br />
          </h2>
          <p class="sub-text">
            It does better: For you, for Philly, and for the planet.
          </p>
        </div>

        <div class="card-media">
          <div class="card-media__img-wrap">
            <img src="assets/images/landing/home/better_grocery_shopping.webp" class="card-media__img big-img"
              alt="Better Grocery Shopping" loading="lazy" />
            <img src="assets/images/landing/home/philly-favorites-seal.png" class="card-media__seal"
              alt="Voted a 2026 Philly Favorite by The Philadelphia Inquirer readers" loading="lazy" />
          </div>
          <h2 class="card-media__title">Better Grocery Shopping</h2>
          <p class="card-media__text">Come for the just-picked fresh, regional, produce. Stay for the sustainably raised
            meats, dairy, baked goods and pantry items. Shop your way — farm share, bulk buy, recurring subscription, or
            a casual swing through the market — and we'll deliver your order right to your door.</p>
          <button class="btn btn-primary rounded-pill d-none d-lg-block d-md-block d-sm-none"
            [routerLink]="['/pages/how-it-works']" aria-label="Learn more about better grocery shopping">Learn More</button>
        </div>
      </div>
      <div class="col-md-5">
        <div class="card-media">
          <img src="assets/images/landing/home/better-grocery-shopping.webp" class="card-media__img"
            alt="From Philly For Philly" loading="lazy" />
          <h2 class="card-media__title">From Philly. For Philly.</h2>
          <p class="card-media__text">90% of every dollar you spend stays in the Philly region. That means every order
            supports local farmers, makers, and neighbors, strengthening the community we all call home.</p>
        </div>
        <div class="card-media">
          <img src="assets/images/landing/home/sustaining_tomorrow.webp" class="card-media__img"
            alt="Sustaining Tomorrow" loading="lazy" />
          <h2 class="card-media__title">Sustaining Tomorrow</h2>
          <p class="card-media__text">Our sourcing puts people and the planet first. With lower food miles, sustainable
            farming practices, and reduced waste, your box helps build a strong local food system that boosts our
            regional economy.</p>
        </div>
      </div>
    </div>
  </div>
</section>



<section class="section-how-it-works">
  <div class="container has-padding-block-5">
    <h2 class="section-title">How it Works</h2>
    <div class="has-animation fadeInUp">
      <div class="how-it-works-tabs">
        <div class="tab-sidebar" role="tablist" aria-label="How it works steps">
          @for (t of tabs; track t.step; let i = $index) {
          <div class="tab-btn" role="tab" [attr.aria-selected]="activeTab === i"
            [attr.tabindex]="activeTab === i ? 0 : -1" [class.active]="activeTab === i"
            (click)="activeTab = i" (keydown.arrowdown)="activeTab = (i + 1) % tabs.length; $event.preventDefault()"
            (keydown.arrowup)="activeTab = (i - 1 + tabs.length) % tabs.length; $event.preventDefault()">

            <span class="tab-num">{{ i + 1 }}</span>
            <span class="tab-text">{{ t.label }}</span>
          </div>
          }
        </div>

        <div class="tab-content-detail">
          @for (t of tabs; track t.step; let i = $index) {
          <div class="tab-pane" role="tabpanel" [class.active]="activeTab === i">

            <div class="tab-pane__text">
              <span class="tab-pane__num">{{ t.step }}</span>
              <div class="tab-pane__header">
                <h2 class="tab-pane__title">{{ t.title }}</h2>

                <div class="tab-pane__steps">
                  @for (s of tabs; track $index) {
                  <div class="step-indicator" [class.active]="activeTab === $index" (click)="activeTab = $index">
                    <span>{{ $index + 1 }}</span>
                  </div>
                  }
                </div>
              </div>

              <p class="tab-pane__p">{{ t.desc }}</p>

              @if (i === 3) {
              <div class="tab-pane__actions-desktop">
                <button class="btn btn-primary mb-5 rounded-pill" [routerLink]="['/pages/how-it-works']">See How to
                  Shop</button><br>
                <a href="" [routerLink]="['/shop']">Start Shopping <i class="fa-solid fa-circle-arrow-right"></i></a>
              </div>
              }
            </div>

            <div class="tab-pane__img">
              <img [src]="t.img" class="img-fluid" loading="lazy" [alt]="t.title" />
            </div>

            @if (i === 3) {
            <div class="tab-pane__actions-mobile">
              <button class="btn btn-primary mb-5 rounded-pill py-3" [routerLink]="['/pages/how-it-works']">See How to
                Shop</button><br>
              <a href="" [routerLink]="['/shop']">Start Shopping <i class="fa-solid fa-circle-arrow-right"></i></a>
            </div>
            }
          </div>
          }
        </div>

      </div>
    </div>
  </div>
</section>



<section>
  <div class="container has-padding-block-5">
    <h2 class="section-title mb-1">Featured Producers</h2>
    <div class="sub-title">
      <p>Our connection with these outstanding brands goes beyond business - it's a true partnership based on mutual
        respect and shared values.</p>
      <div class="action-btn">
        <button class="btn btn-secondary rounded-pill" [routerLink]="['/pages/producers']">Meet Our Producers</button>
      </div>
    </div>
    <div class="producer-card-wrap has-animation fadeInUp">
      @for (item of producers; track item) {
      <div class="producer-card" role="img" [attr.aria-label]="item.title" [style.background-image]="'url(' + item.img + ')'">
        <div>
          <div class="producer-card__title">{{item.title}}</div>
          <p class="producer-card__text">{{item.text}}</p>
          <a [href]="item.link" class="producer-card__link" target="_blank" rel="noopener noreferrer">[Read More...]</a>
        </div>
      </div>
      }
    </div>
  </div>
</section>


<section class="has-padding-block-5">
  <div class="container">
    <div class="row">
      <div class="col-md-6 pe-5 mb-3">
        <img src="assets/images/landing/home/about.webp" alt="About Philly Foodworks team" class="img-fluid" loading="lazy">
      </div>
      <div class="col-md-6 d-flex align-items-center">
        <div class="text-sm-start text-center">
          <h2 class="section-title">About Us</h2>
          <hr>
          <p>Philly Foodworks is powered by real people who care about good food, strong communities, and a better food
            system. Get to know the team who makes it happen.</p>
          <button class="btn btn-secondary rounded-pill" [routerLink]="['/pages/about-us']">About Us</button>
        </div>
      </div>
    </div>
  </div>
</section>


<section class="section-testimonials has-animation fadeInUp">
  <div class="container has-padding-block-5">
    <h2 class="section-title is-center mb-4">Why People Love Us</h2>
    <div class="testimonials">
      @for (item of testimonials; track item) {
      <div class="testimonial" [ngClass]="{'is-alternate': item.isAlternate}">
        <div class="testimonial__img">
          <img [src]="item.img" [alt]="item.name">
        </div>
        <div class="testimonial__detail">
          <div class="quote"></div>
          <p class="testimonial__text" [ngClass]="{'is-alternate': item.isAlternate}">{{ item.quote }}</p>
          <div class="testimonial__name">
            &minus; {{ item.name }}
            @if (item.meta != '') {
            , {{ item.meta }}
            }
          </div>
        </div>
      </div>
      }
    </div>
  </div>
</section>

<section class="has-padding-block-5">
  <div class="container text-center">
    <button class="btn btn-secondary rounded-pill" (click)="openModalCheckAddress()">
      See if We Deliver to You
    </button>
  </div>
</section>

<section class="has-padding-block-5 animated fadeIn">
  <div class="container">
    <div class="px-md-5">
      <h2 class="section-title">FAQs</h2>
      <div ngbAccordion [closeOthers]="true">
        @for (item of faq; track item) {
        <div ngbAccordionItem [collapsed]="true">
          <h2 ngbAccordionHeader>
            <button ngbAccordionButton>{{ item.question }}</button>
          </h2>
          <div ngbAccordionCollapse (click)="$event.stopPropagation()">
            <div ngbAccordionBody>
              <div [innerHTML]="item.answer"></div>
            </div>
          </div>
        </div>
        }
      </div>
      <div class="d-flex justify-content-center mt-5">
        <button class="btn btn-secondary rounded-pill" [routerLink]="['/pages/faq/prospective-members']">View All
          FAQs</button>
      </div>
    </div>
  </div>
</section>


<app-footer></app-footer>